import AppLayout from "@/app/AppLayout";
import { AsyncBoundary, PageHeader } from "@/ui/patterns";
import { useUserBusiness } from "@/features/settings/hooks/useUserBusiness";
import { NoBusinessYet } from "@/features/settings/components/NoBusinessYet";
import { ReservationsScreen } from "./components/ReservationsScreen";

export default function ReservationsPage() {
  const { hasBusiness, isLoading, error, refetch } = useUserBusiness();

  return (
    <AppLayout>
      <AsyncBoundary<boolean>
        data={hasBusiness}
        isLoading={isLoading}
        error={error}
        onRetry={refetch}
      >
        {(partnerHasBusiness) =>
          partnerHasBusiness ? (
            <div className="space-y-10">
              <PageHeader
                title="Rezervace"
                description="Vše, co si u vás zákazníci koupili — nahoře to, co čeká na vaši odpověď."
              />
              <ReservationsScreen />
            </div>
          ) : (
            <NoBusinessYet
              eyebrow="Rezervace"
              headline="Rezervace přijdou až po podniku."
              body="Zákazníci si rezervují slevové termíny konkrétního podniku. Než ten váš nastavíte, nemá se tu co objevit — čekat na první rezervaci má smysl až potom."
            />
          )
        }
      </AsyncBoundary>
    </AppLayout>
  );
}
